<template>
  <div class="userHead">
    <div class="background-box"></div>
    <div class="userinfo-box">
      <div class="userInfo">
        <div class="img-box">
          <img src="~@/assets/image/user/user_logo.png" alt=""/>
        </div>
        <div class="user-data">
          <div class="name">
            <span v-if="usertype === 'group'">{{ userInfo.realName }}</span>
            <span v-else>{{ userInfo.name }}</span>
            <template v-if="usertype === 'group'">
              <img v-if="userInfo.type === 'guide'" src="~@/assets/image/user/guide_logo.png" alt="">
              <img v-else-if="userInfo.type === 'organization'" src="~@/assets/image/user/organization_logo.png" alt="">
            </template>
          </div>
          <div class="phone">{{ userInfo.mobile }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "userHead",
  props: ["userInfo", "usertype"],
};
</script>

<style scoped lang='less'>
.userHead {
  height: 5.613333rem;
  padding: .986667rem .76rem 0 .573333rem;
  display: flex;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  .background-box{
    position: absolute;
    height: 5.613333rem;
    background: url('~@/assets/image/common/common_header.png') no-repeat center center / auto 100%;
    filter: blur(.2rem);
    transform: scale(1.5) translate(-5%, 0%);
    width: 100vw;
    z-index: -9;
  };
  .userinfo-box{
    display: flex;
    align-items: center;
    height: 1.813333rem;
    justify-content: space-between;
    width: 100%;
  }
  .userInfo{
    display: flex;
    align-items: center;
    .img-box{
      position: relative;
      border-radius: .24rem;
      overflow: hidden;
      width: 1.813333rem;
      height: 1.813333rem;
      img {
        width: 100%;
      }
    }
    .user-data{
      margin-left: .4rem;
      color: #fff;
      .name{
        font-size: .48rem;
        font-weight: bold;
        line-height: .666667rem;
        position: relative;
        display: flex;
        align-items: center;
        img{
          width: .493333rem;
        }
      }
      .phone{
        margin-top: .066667rem;
        font-size: .4rem;
        line-height: .56rem;
      }
    }
  }
}
</style>
